import React from "react";
import { Loader } from "tabler-icons-react";

/**
 * Composant pour les boutons d'action du formulaire
 */
const ProfileActions = ({ isEditing, isUpdating, onEdit, onCancel }) => {
  if (!isEditing) {
    return (
      <button
        onClick={onEdit}
        className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
      >
        Modifier
      </button>
    );
  }

  return (
    <div className="flex gap-3 mt-6">
      <button
        type="submit"
        disabled={isUpdating}
        className="flex-1 px-4 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
      >
        {isUpdating ? (
          <>
            <Loader className="animate-spin mr-2" size={20} />
            Enregistrement...
          </>
        ) : (
          "Enregistrer"
        )}
      </button>
      <button
        type="button"
        onClick={onCancel}
        disabled={isUpdating}
        className="flex-1 px-4 py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition disabled:opacity-50"
      >
        Annuler
      </button>
    </div>
  );
};

export default ProfileActions;
